import { createSlice } from "@reduxjs/toolkit";
import { addAssignedLicenseAction } from "../../actions/license/addAssignedLicenseAction";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const addAssignedLicenseReducer = createSlice({
  name: "addAssignedLicense",
  initialState,
  reducers: {
    clearaddAssignedLicenseState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAssignedLicenseAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAssignedLicenseAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addAssignedLicenseAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearaddAssignedLicenseState } =
  addAssignedLicenseReducer.actions;
export default addAssignedLicenseReducer.reducer;
